import { useGetSpace } from "@/data/api";
import React from "react";
import { PartnerConfig } from "@/offering/partner_config";
import { useParams } from "react-router-dom";
import { TemplateOfferingCheckoutStripeEvent } from "./template_offering_checkout_stripe_event";
import { TemplateOfferingCheckoutMeetingRoomV2 } from "./template_offering_checkout_meeting_room";
import { TemplateOfferingCheckoutStripeDailyOffice } from "./template_offering_checkout_stripe_daily_office";

interface TemplateOfferingCheckoutRoomsGalleryProps {
  partnerConfig: PartnerConfig;
}

interface TemplateOfferingCheckoutRoomsGalleryParams {
  spaceID: string;
}

export const TemplateOfferingCheckoutRoomsGallery = (
  props: TemplateOfferingCheckoutRoomsGalleryProps
) => {
  const { partnerConfig } = props;

  const { spaceID } = useParams<TemplateOfferingCheckoutRoomsGalleryParams>();

  const space = useGetSpace(spaceID);

  return space.spaceType === "meeting_room" ? (
    <TemplateOfferingCheckoutMeetingRoomV2 partnerConfig={partnerConfig} />
  ) : space.spaceType === "event_space" ? (
    <TemplateOfferingCheckoutStripeEvent partnerConfig={partnerConfig} />
  ) : space.spaceType === "private_office" ? (
    <TemplateOfferingCheckoutStripeDailyOffice partnerConfig={partnerConfig} />
  ) : null;
};
